import Index from './index.vue'

export default {
  name: 'applicationList',
  path: '/v-admin/application',
  component: Index,
  meta: {
    isInclude: true,
    permission: ['PERM_VIEW_UNIVERSAL_APPLICATION_LIST', 'PREMIUM_HR_DASHBOARD'],
    titleI18nKey: 'admin.application.applicantList.title.list'
  }
}
